import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useState } from "react";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from "file-saver";
import { MdDownload } from "react-icons/md";
import { RiArrowGoBackLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import Request from "../../Request";
import { logout } from "../../actions/AppActions";

const RelatoriosGerais = (props) => {const { t } = usePreferences();
  const { faculdade_id, faculdade_name } = props;
  const [loadingReport, setLoadingReport] = useState("");
  const dispatch = useDispatch();
  const user = useSelector((state) => state.AppReducer.user);

  const entityLabel = user?.empresa == null || user.empresa.change_text === false ? "instituição" : "processo";

  const reports = [
  {
    type: "login",
    title: t("legacy_quem_ja_fez_login"),
    description: t("ui_lista_os_candidatos_que_acessaram_a_plataforma_2258f573")
  },
  {
    type: "tela_avaliacao_nao_iniciada",
    title: t("legacy_permissoes_concedidas"),
    description: t("ui_lista_quem_concedeu_permissoes_e_chegou_na_tela_de_47155e81")
  }];


  const downloadReport = async (type) => {
    setLoadingReport(type);

    try {
      const response = await Request.Get(`faculdade/get_relatorio_geral/${faculdade_id}/${type}`);
      if (response === undefined) return;

      if (response.message === "Unauthenticated.") {
        dispatch(logout());
        return;
      }

      let csv = "Nome;CPF;Número de Inscrição\n";
      if (response.result) {
        response.result.forEach((item) => {
          csv += `${item.name};${item.cpf};${item.numero_inscricao}\n`;
        });
      }

      const blob = new Blob([csv], { type: "text/plain" });
      saveAs(blob, `relatorio_${type}_${moment().format("YYYY-MM-DD-HH:mm:ss")}.csv`);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingReport("");
    }
  };

  return (
    <div className="module-card-container">
            <div className="module-breadcrumb">
                <button
          className="breadcrumb-back"
          onClick={() => props.setState({ activeTab: -1 })}>{t("dashboard")}


        </button>

                <span>/</span>

                <strong>{t("legacy_relatorios")}</strong>
            </div>

            <div className="module-title-row">
                <div>
                    <h3 style={{ fontWeight: "bold" }}>{t("legacy_relatorios")}</h3>
                    <p>{t("ui_baixe_relatorios_gerais_d7ab5b34")}
            {entityLabel === "instituição" ? "da" : "do"} {entityLabel} "{faculdade_name}".
                    </p>
                </div>

                <button
          className="btn-dashboard-modern"
          onClick={() => props.setState({ activeTab: -1 })}>

                    <RiArrowGoBackLine />{t("dashboard")}

        </button>
            </div>

            <div className="table-modern-card">
                <table className="table">
                    <thead>
                        <tr>
                            <th>{t("legacy_relatorio")}</th>
                            <th>{t("label_description")}</th>
                            <th style={{ width: 130 }}>{t("label_actions")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reports.map((report) =>
            <tr key={report.type}>
                                <td>
                                    <strong>{report.title}</strong>
                                </td>
                                <td>{report.description}</td>
                                <td>
                                    <div className="actions-group">
                                    <button
                  type="button"
                  className="action-btn success"
                  onClick={() => downloadReport(report.type)}
                  disabled={loadingReport !== ""}
                  title={t("legacy_download_relatorio")}>

                                        {loadingReport === report.type ?
                  <CircularProgress size={16} /> :

                  <MdDownload size={17} />
                  }
                                    </button>

                                    </div>
                                    </td>
                            </tr>
            )}
                    </tbody>
                </table>
            </div>
        </div>);

};

export default RelatoriosGerais;